import React, { FC, useEffect, useState } from 'react'
import { ITopPerformance, TTopPerformance } from '../../../models/analytics'
import RadioInput from '../../UI/Inputs/Radio/Simple'
import './TopPerformance.scss'
import { format } from 'date-fns/esm'
import { convertToTimeZone } from 'date-fns-timezone'
import FacebookRoundIcon from '../../UI/Icons/socials/FacebookRound'
import InstagramRoundIcon from '../../UI/Icons/socials/InstagramRound'
import LinkedinRoundIcon from '../../UI/Icons/socials/LinkedinRound'
import TwitterRoundIcon from '../../UI/Icons/socials/TwitterRound'
import { SOCIAL_NETWORK } from '../../../models/post'

interface ITopPerformanceProps {
  type: TTopPerformance
  setType: React.Dispatch<React.SetStateAction<TTopPerformance>>
  data: ITopPerformance[] | []
  social: SOCIAL_NETWORK
}

const TopPerformance: FC<ITopPerformanceProps> = ({ type, setType, data, social }) => {

  return (
    <div className='analytics-top-performance'>
      <div className='content__header'>
        <div className='content__title'>TOP PERFORMING {social === SOCIAL_NETWORK.TWITTER_SOCIAL?"TWEETS":"POSTS"}</div>
        <div className='radio__input'>
          <RadioInput
            label='Based on Reach'
            name='option'
            value={TTopPerformance.reach}
            checked={type === TTopPerformance.reach}
            onChange={({ target: { value } }: any) => setType(value)}
          />
        </div>
        <div className='radio__input'>
          <RadioInput
            label='Based on Total Engagement'
            name='option'
            value={TTopPerformance.engagement}
            checked={type === TTopPerformance.engagement}
            onChange={({ target: { value } }: any) => setType(value)}
          />
          {/* <span className='subtitle'> (Likes, Comments, Shares, Followers)</span> */}
          <span className='subtitle'> &nbsp;(Likes, Comments, Shares)</span>
        </div>
      </div>
      <div className='labels'>
        <div>Content information</div>
        <div>Publish date</div>
        <div>Reach</div>
        <div>Likes</div>
        <div>Comments</div>
        <div>Shares</div>
        {/* <div>Followers</div> */}
      </div>
      {data && data.length > 0 ? (
        data.map((v: ITopPerformance) => (
          <div className='list_items'>
            <div className='description'>
              <div className='list_post-image'>
                {v.postSocial && v.postSocial.attachments && v.postSocial.attachments[0] ? (
                  <img
                    className='create-agency__logo__image'
                    src={
                      v.postSocial.attachments[0].object_data.previews.medium ||
                      v.postSocial.attachments[0].object_data.previews.small
                    }
                  />
                ) : null}
              </div>
              <div className='description-layout'>
                <div>
                  {social === SOCIAL_NETWORK.FACEBOOK_SOCIAL ? (
                    <FacebookRoundIcon />
                  ) : social === SOCIAL_NETWORK.INSTAGRAM_SOCIAL ? (
                    <InstagramRoundIcon />
                  ) : social === SOCIAL_NETWORK.LINKEDIN_SOCIAL ? (
                    <LinkedinRoundIcon />
                  ) : (
                    <TwitterRoundIcon />
                  )}
                  {v.postSocial && v.postSocial.message ? (
                    <p className='description-text'>
                     {v.postSocial.message}
                    </p>
                  ) : null}
                </div>
              </div>
            </div>
            <div className='description-time'>
              {v.scheduled_at
                ? format(convertToTimeZone(new Date(v.scheduled_at), { timeZone: v.timezone }), 'dd LLL yyyy hh:mm aa')
                : ''}
            </div>
            <div className='description-time'>{v.reach}</div>
            <div className='description-time'>{v.likes}</div>
            <div className='description-time'>{v.comments}</div>
            <div className='description-time'>{v.shares}</div>
            {/* <div className='description-time'>0</div> */}
          </div>
        ))
      ) : (
        <div className='list_items'>
          <div className='no-data'>No post found</div>
        </div>
      )}
    </div>
  )
}

export default TopPerformance
